import { Line } from 'react-chartjs-2';
import Colors from 'assets/Colors';
import Loading from 'components/common/loading';
import { useTranslation } from 'react-i18next';
import s from './styles';

const options = (t) => ({
  plugins: {
    legend: {
      display: false,
    },
  },
  responsive: true,
  maintainAspectRatio: false,

  scales: {
    x: {
      display: true,
      title: {
        display: true,
        text: t('containers.Dashboard.LineChart.hours'),
      },
      ticks: {
        maxTicksLimit: 11,
      },
    },
    y: {
      display: true,
      title: {
        display: true,
        text: t('containers.Dashboard.LineChart.money'),
      },
      suggestedMin: 0,
      suggestedMax: 100,
    },
  },
});

function LineChart({ list, loading }) {
  const { t } = useTranslation();
  const data = {
    labels: [],
    datasets: [
      {
        data: [],
        fill: false,
        borderColor: Colors.text_primary,
        tension: 0.1,
      },
    ],
  };

  list.forEach((element) => {
    data.labels.push(`${element.label}h`);
    data.datasets[0].data.push(element.number);
  });

  return (
    <s.Container>
      {loading ? (
        <Loading height="100%" size="middle" />
      ) : (
        <>
          <s.Title>{t('containers.Dashboard.LineChart.earningsToday')}</s.Title>
          <s.ChartWrapper>
            <Line data={data} options={options(t)} />
          </s.ChartWrapper>
        </>
      )}
    </s.Container>
  );
}

export default LineChart;
